enum DriverEditFormOfEmploymentType {
  B2B = "B2B",
  EMPLOYMENT = "EMPLOYMENT",
}

export default DriverEditFormOfEmploymentType;
